import { useSeo } from '@/hooks/useSeo';
import { siteInfo } from '@/mocks/site';
import { hotList } from '@/mocks/hotList';
import { faqs } from '@/mocks/faqs';
import TickerStrip from '@/pages/home/components/TickerStrip';
import HomeHero from '@/pages/home/components/HomeHero';
import HotSpotSection from '@/pages/home/components/HotSpotSection';
import RankingPreview from '@/pages/home/components/RankingPreview';
import TopicSection from '@/pages/home/components/TopicSection';
import LatestSection from '@/pages/home/components/LatestSection';
import FaqSection from '@/pages/home/components/FaqSection';
import SubscribeSection from '@/pages/home/components/SubscribeSection';

export default function Home() {
  useSeo({
    title: '瓜圈速报 - 娱乐热点热度排行与今日热议焦点',
    description:
      '瓜圈速报汇聚全网娱乐热点，提供瓜圈速报热度排行、热门榜单与话题榜，实时更新今日热议焦点，吃瓜群众速来围观今日爆款瓜，流量焦点一网打尽。',
    keywords: '瓜圈速报,瓜圈速报热度排行,瓜圈速报热门榜单,瓜圈速报话题榜,今日热议焦点',
    path: '/',
    jsonLd: [
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: siteInfo.name,
        description: siteInfo.description,
        email: siteInfo.email,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: siteInfo.name,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://example.com/ranking?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        name: '瓜圈速报热度排行',
        itemListElement: hotList.slice(0, 8).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          url: `https://example.com/article/${item.id}`,
        })),
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((faq) => ({
          '@type': 'Question',
          name: faq.question,
          acceptedAnswer: { '@type': 'Answer', text: faq.answer },
        })),
      },
    ],
  });

  return (
    <>
      <TickerStrip />
      <HomeHero />
      <HotSpotSection />
      <RankingPreview />
      <TopicSection />
      <LatestSection />
      <FaqSection />
      <SubscribeSection />
    </>
  );
}